// bed
export const mdBed = [
  '24, 24',
  '<path d="M2 19v-6q0-.675.275-1.225T3 10.8V8q0-1.25.875-2.125T6 5h4q.575 0 1.075.213.5.212.925.587.425-.375.925-.587Q13.425 5 14 5h4q1.25 0 2.125.875T21 8v2.8q.45.425.725.975Q22 12.325 22 13v6h-2v-2H4v2Zm11-9h6V8q0-.425-.288-.713Q18.425 7 18 7h-4q-.425 0-.712.287Q13 7.575 13 8Zm-8 0h6V8q0-.425-.287-.713Q10.425 7 10 7H6q-.425 0-.713.287Q5 7.575 5 8Zm-1 5h16v-2q0-.425-.288-.713Q19.425 12 19 12H5q-.425 0-.713.287Q4 12.575 4 13Zm16 0H4h16Z"/>'
]
